import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

@Pipe({
  name: 'toIterable',
})
export class ObjectToIterablePipe implements PipeTransform {
  transform(value: Object): Object[] {
    return _.values(value);
  }
}
